export const Sliders = {
  onLoad: function() {
    if( $('.reviews-slider').length) {
      const slides_count = $('.reviews-slider > div').length;
      const slidesToShow = {
        xs: 1,
        md: 1.5,
        lg: 2.5,
        xl: 3.5,
      };
      $('.reviews-slider').slick({
        infinite: false,
        slidesToShow: slidesToShow.xl, // 3.5,
        slidesToScroll: 1,
        arrows: true,
        // dots: true,
        swipeToSlide: true,
        nextArrow: $('.reviews-slider-next'),
        prevArrow: $('.reviews-slider-prev'),
        responsive: [
          {
            breakpoint: 768,
            settings: {
              slidesToShow: slidesToShow.xs, // 1
            },

          }, {
            breakpoint: 992,
            settings: {
              slidesToShow: slidesToShow.md, // 1.5
            },

          }, {
            breakpoint: 1200,
            settings: {
              slidesToShow: slidesToShow.lg, // 2.5
            },
        }],
      });
      $('.reviews-slider').on('afterChange', function(event, slick, currentSlide) {
        const $prev_btn = $('.reviews-slider-prev');
        const $next_btn = $('.reviews-slider-next');
        if (currentSlide === 0) {
          $prev_btn.css('visibility', 'hidden');
        } else if (currentSlide === (slides_count - parseInt(Sliders.getSlidesToShowByWindowWidth(slidesToShow)))) {
          $next_btn.css('visibility', 'hidden');
        } else {
          $prev_btn.css('visibility', 'initial');
          $next_btn.css('visibility', 'initial');
        }
      });
    }
    // window.onload = this.onResize;
    // window.onresize = this.onResize;
  },
  onResize: function() {
    $('.review-container').height('unset');
    var maxHeight = 0;
    $('.review-container').each(function(){
      if ($(this).height() > maxHeight) { maxHeight = $(this).height(); }
    });
    $('.review-container').height(maxHeight);
  },
  getSlidesToShowByWindowWidth: function(slidesToShow) {
    const window_width = $(window).width();
    if (window_width < 768) {
      return slidesToShow.xs;
    } else if (window_width < 991) {
      return slidesToShow.md;
    } else if (window_width < 1200) {
      return slidesToShow.lg;
    }
    return slidesToShow.xl;
  },
}



// WEBPACK FOOTER //
// ./scripts/modules/Sliders.js